import { all } from 'redux-saga/effects';
import auth from './auth/sagas';
import clientTransacoes from './client/transacoes/sagas';
import clientDashboard from './client/dashboard/sagas';
import clientRecebimentos from './client/recebimentos/sagas';
import clientMaquinaVirtual from './client/maquinaVirtual/sagas';
import clientSimulador from './client/simulador/sagas';

export default function* rootSaga() {
	return yield all([
		auth,
		clientTransacoes,
		clientDashboard,
		clientRecebimentos,
		clientMaquinaVirtual,
		clientSimulador,
	]);
}
